import { createApi } from '@reduxjs/toolkit/query/react';
import { BalanceResponse, StatisticsResponse, InvoicesResponse, PayInvoiceResponse, GenerateInvoiceResponse } from '@/app/billing/types/billing';
import { privateBaseQuery } from '../base/private/privateBaseQuery';

export const billingApi = createApi({
  reducerPath: 'billingApi',
  baseQuery: privateBaseQuery(),
  tagTypes: ['Balance', 'Statistics', 'Invoices'],
  endpoints: (builder) => ({
    getBalance: builder.query<BalanceResponse, void>({
      query: () => ({
        url: '/billing/balance',
        method: 'GET',
      }),
      providesTags: ['Balance'],
    }),
    getStatistics: builder.query<StatisticsResponse, { dateFrom: string; dateTo: string }>({
      query: ({ dateFrom, dateTo }) => ({
        url: '/billing/statistics',
        method: 'GET',
        params: {
          date_from: dateFrom,
          date_to: dateTo,
        },
      }),
      providesTags: ['Statistics'],
    }),
    getInvoices: builder.query<InvoicesResponse, { dateFrom: string; dateTo: string }>({
      query: ({ dateFrom, dateTo }) => ({
        url: '/billing/invoices',
        method: 'GET',
        params: {
          date_from: dateFrom,
          date_to: dateTo,
        },
      }),
      providesTags: ['Invoices'],
    }),
    payInvoice: builder.mutation<PayInvoiceResponse, { invoiceId: number }>({
      query: ({ invoiceId }) => ({
        url: `/billing/invoices/${invoiceId}/pay`,
        method: 'POST',
      }),
    }),
    generateInvoice: builder.mutation<GenerateInvoiceResponse, { dateFrom: string; dateTo: string; locale?: string }>({
      query: ({ dateFrom, dateTo, locale }) => ({
        url: '/billing/invoices/generate',
        method: 'POST',
        body: { date_from: dateFrom, date_to: dateTo },
        headers: { Locale: locale ?? 'en' },
      }),
      invalidatesTags: ['Invoices'],
    }),
  }),
});

export const { useGetBalanceQuery, useGetStatisticsQuery, useGetInvoicesQuery, usePayInvoiceMutation, useGenerateInvoiceMutation } = billingApi;
